function kdProfileCreateDataToJson(kdProfileCreateData) {

  let windDirection = 0;
  switch (kdProfileCreateData.windDirection) {
  case "Head Seas":
    windDirection = 0;
    break;
  case "Beam Seas":
    windDirection = 1;
    break;
  case "Following Seas":
    windDirection = 2;
    break;
  }

  return {
    profileName: kdProfileCreateData.profileName,
    valuesList: kdProfileCreateData.valuesList,
    draft: kdProfileCreateData.draft,
    trim: kdProfileCreateData.trim,
    windDirection: windDirection,
    trueWind: kdProfileCreateData.trueWind,
    lhv: kdProfileCreateData.lhv,
    fouling: kdProfileCreateData.fouling,
    useLatestFouling: Boolean(kdProfileCreateData.useLatestFouling),
    date_min: kdProfileCreateData.minDate,    // ← add
    date_max: kdProfileCreateData.maxDate,
  };
}

function kdProfileDataToJson(kdProfileData) {
  return {
    id: kdProfileData.id,
    ...kdProfileCreateDataToJson(kdProfileData)
  };
}

export { kdProfileCreateDataToJson, kdProfileDataToJson };
